import { VUwebSearchService } from "@/shared/services/azure-search-service";
import { MutationTree } from "vuex";
import { IConfig } from "../models/config-viewmodel";
import { SearchResults } from "../models/search-viewmodel";
import { SearchState } from "../models/store-viewmodel";

export default< MutationTree<SearchState>> {
    setConfig(state, config: IConfig) {
        state.config = config;
    },

    setLoading(state, loading: boolean) {
        state.loading = loading;
    },

    setSearchActive(state, status: boolean) {
        state.searchActive = status;
    },

    setError(state, error: string) {
        state.error = error;
    },

    setSearchQuery(state, query: string) {
        state.searchQuery = query;
    },

    setExternalSearchOption(state, isExternalSearch: boolean) {
        state.isExternalSearchActive = isExternalSearch;
    },

    setSearchResults(state, results: SearchResults) {
        state.searchResults = results;
    },

    setEmployeeResults(state, results: SearchResults) {
        state.employeeResults = results;
    },

    setAzureSearch(state) {
        state.azureService = new VUwebSearchService(state.config.searchSettings.index, state.config.endpoint);
    }
}